import { Link, Stack, Text } from '@chakra-ui/react'
import React from 'react'

export default function Footer() {
  return (
    <Stack
      position={'fixed'}
      right={0}
      bottom={0}
      color={'gray.400'}
      fontSize={'xs'}
      direction={'row'}
      display={'inline-block'}
      spacing={6}
      bg={'whiteAlpha.600'}
      zIndex={2}
      borderRadius={'lg'}
      p={1}
      backdropFilter={'blur(5px) saturate(100%)'}
      sx={{
        '@media print': {
          'a::after': { content: '" - " attr(href) ""' },
          '& a': {
            textDecoration: 'none',
          },
        },
      }}
    >
      <Text display={'inline'}>
        Copyright © {new Date().getFullYear()}{' '}
        <Link
          color="inherit"
          href="https://www.actioniq.com/"
          target="_blank"
          textDecoration={'underline'}
        >
          ActionIQ
        </Link>
      </Text>
      <Text as={'span'}>
        Powered by{' '}
        <Link
          color="inherit"
          href="https://radiusinsights.com/"
          target="_blank"
          textDecoration={'underline'}
        >
          Radius Labs
        </Link>
      </Text>
    </Stack>
  )
}
